export default {
  getJumpHostStatusList: state => state.gridData,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/jumpHostStatus/jumpHostStatusGetter.js